import { SystemStyleObject } from "@chakra-ui/react";

export const sidebarContainer: SystemStyleObject = {
    position: { base: "static", md: "sticky" },
    top: "24px",
    alignSelf: "flex-start",
}

export const sidebarActionCard: SystemStyleObject = {
    p: 4,
    gap: 3,
    bg: "white",
    display: "flex",
    alignItems: "center",
    borderRadius: 12,
    cursor: "pointer",
    boxShadow: "0px 1px 2px 0px rgba(0, 0, 0, 0.06), 0px 1px 3px 0px rgba(0, 0, 0, 0.10)",
    transition: "transform 0.2s ease, box-shadow 0.2s ease",
    _hover: {
        transform: "translateY(-2px)",
        boxShadow: "0px 4px 12px 0px rgba(0, 0, 0, 0.08), 0px 2px 6px 0px rgba(0, 0, 0, 0.12)",
    }
}

export const walletOption: SystemStyleObject = {
    w: 220,
    p: 3,
    gap: 3,
    alignItems: "center",
    borderRadius: 12,
    border: "1px solid",
    borderColor: "blackAlpha.200",
    bg: "white",
    cursor: "pointer",
    transition: "transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease",
    _hover: {
        transform: "scale(1.02)",
        boxShadow: "0px 4px 12px 0px rgba(0, 0, 0, 0.08)",
        borderColor: "blackAlpha.300",
    }
}
